import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { MdDoneAll, MdOutlineHandshake, MdOutlineInsights, MdOutlineLocalShipping, MdOutlineVerified } from "react-icons/md";
import Footer from "./Footer";
import p3 from "../assets/Terrazzo/banner2.jpg";

export default function Values() {
  useEffect(() => {
    AOS.init({
      duration: 700,
      easing: "ease-out-cubic",
      once: true,
      offset: 80,
    });
    AOS.refresh();
  }, []);
  
  const whyWorkPoints = [
    "Reliable supply and delivery coordination",
    "Quality materials aligned with project specifications",
    "Responsive communication and technical support",
    "Experience serving commercial and institutional clients",
  ];

  const executionData = {
    id: "delivery",
    banner: p3,
    icon: <MdOutlineVerified size={24} />,
    title: "Execution Strengths",
    summary: "How we structure projects to keep delivery predictable and quality-focused.",
    content: [
      "Clear quotations and scope alignment",
      "Reliable material sourcing and coordination",
      "On-time dispatch and transportation support",
      "Consistent communication through fulfillment",
    ],
  };

  return (
  <>
    <section className="MainBodySection values-section mb-5" style={{width:"90%", marginLeft:"5%", marginTop:"5%"}} id="about-why-work">
      
      {/* Section 1: Why Work With Us */}
      <div className="why-work-wrapper mb-5" data-aos="fade-up">
        <div className="about-center-head">
          <h3 className="font-bold about-center-section-title my-3 fs-3 section-title-primary">
            Why Work with Group V Limited?
          </h3>
          <p className="about-center-why-text m-0">
            We are committed to supporting your project from specification to delivery with dependable
            execution, clear communication, and practical technical guidance.
          </p>
        </div>

        <div className="about-center-why-grid">
          {whyWorkPoints.map((point, index) => (
            <div
              key={point}
              className="about-center-why-point"
              data-aos="fade-right"
              data-aos-delay={80 + index * 60}
            >
              <span className="about-center-why-index font-semi-bold">0{index + 1}</span>
              <p className="about-center-why-point-text m-0">{point}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Section 2: Execution Strengths */}
      <div className="execution-wrapper mt-5" data-aos="fade-up" data-aos-delay="200">
        <div className="about-center-head">
          <h3 className="font-bold about-center-section-title my-3 text-primary section-title-secondary">
            Our Execution Approach
          </h3>
          <p className="about-center-why-text m-0">
            Structured processes that ensure every project milestone is met with precision and accountability.
          </p>
        </div>

        <div className="execution-card">
          <div className="execution-banner">
            <img src={executionData.banner} alt={executionData.title} />
            <div className="execution-overlay">
              <div className="execution-badge">
                <span className="badge-icon">{executionData.icon}</span>
                <span className="badge-title">{executionData.title}</span>
              </div>
            </div>
          </div>

          <div className="execution-body">
            <p className="execution-summary">{executionData.summary}</p>
            
            <div className="execution-list-wrapper">
              <h4 className="execution-list-title">
                <MdOutlineVerified className="title-icon" />
                Key Strengths
              </h4>
              <ul className="execution-list">
                {executionData.content.map((item, index) => (
                  <li key={index} className="execution-list-item">
                    <span className="list-check"><MdDoneAll size={18} /></span>
                    <span className="list-text">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

    </section>
    <Footer/>
    <style>{`
      .values-section {
        padding: 40px 0;
      }

      .why-work-wrapper,
      .execution-wrapper {
        margin: 0 auto;
      }

      /* Section Titles */
      .section-title-primary {
        color: var(--primaryColor);
        font-size: 28px;
        font-weight: 700;
      }

      .section-title-secondary {
        color: #0f2f56;
        font-size: 28px;
        font-weight: 700;
      }

      .about-center-head {
        max-width: 860px;
        margin: 0 auto 30px;
        text-align: center;
      }

      .about-center-why-text {
        max-width: 700px;
        margin: 12px auto 0;
        font-size: 16px;
        line-height: 1.6;
        color: #475569;
        opacity: 0.9;
      }

      /* Why Work Grid */
      .about-center-why-grid {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 16px;
        max-width: 980px;
        margin: 0 auto;
      }

      .about-center-why-point {
        position: relative;
        border: 1px solid rgba(255, 255, 255, 0.16);
        background: linear-gradient(140deg, #0f2f56, #194a84);
        border-radius: 16px;
        padding: 20px 18px 20px 16px;
        display: flex;
        gap: 14px;
        align-items: flex-start;
        box-shadow: 0 12px 24px rgba(6, 24, 44, 0.18);
        overflow: hidden;
      }

      .about-center-why-point::before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 4px;
        background: linear-gradient(180deg, #9fe3ff, rgba(255, 255, 255, 0.2));
      }

      .about-center-why-index {
        min-width: 48px;
        text-align: center;
        border-radius: 999px;
        padding: 6px 10px;
        font-size: 13px;
        letter-spacing: 0.08em;
        background: rgba(255, 255, 255, 0.18);
        color: #ffffff;
        border: 1px solid rgba(255, 255, 255, 0.24);
        text-transform: uppercase;
        font-weight: 700;
      }

      .about-center-why-point-text {
        font-size: 15px;
        line-height: 1.6;
        color: #ffffff;
        opacity: 0.95;
        margin: 0;
      }

      /* Execution Card */
      .execution-card {
        background: #ffffff;
        border-radius: 24px;
        overflow: hidden;
        box-shadow: 
          0 20px 40px -10px rgba(15, 23, 42, 0.1),
          0 0 0 1px rgba(226, 232, 240, 0.6);
        display: flex;
        flex-direction: column;
        transition: transform 0.3s ease, box-shadow 0.3s ease;
        max-width: 900px;
        margin: 0 auto;
      }

      .execution-card:hover {
        transform: translateY(-5px);
        box-shadow: 
          0 25px 50px -12px rgba(15, 23, 42, 0.15),
          0 0 0 1px rgba(56, 189, 248, 0.3);
      }

      /* Banner */
      .execution-banner {
        position: relative;
        height: 300px;
        width: 100%;
        overflow: hidden;
      }

      .execution-banner img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.6s ease;
      }

      .execution-card:hover .execution-banner img {
        transform: scale(1.05);
      }

      .execution-overlay {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 24px;
        background: linear-gradient(to top, rgba(15, 23, 42, 0.95), transparent);
        display: flex;
        align-items: flex-end;
      }

      .execution-badge {
        display: inline-flex;
        align-items: center;
        gap: 12px;
        background: rgba(255, 255, 255, 0.15);
        backdrop-filter: blur(10px);
        padding: 10px 20px;
        border-radius: 99px;
        border: 1px solid rgba(255, 255, 255, 0.25);
        color: #ffffff;
        font-weight: 600;
        font-size: 16px;
        box-shadow: 0 4px 16px rgba(0,0,0,0.15);
      }

      .badge-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, #38bdf8, #0ea5e9);
        color: #ffffff;
        width: 32px;
        height: 32px;
        border-radius: 50%;
      }

      /* Body */
      .execution-body {
        padding: 36px;
        display: flex;
        flex-direction: column;
        gap: 28px;
      }

      .execution-summary {
        font-size: 17px;
        line-height: 1.7;
        color: #334155;
        margin: 0;
        font-weight: 500;
      }

      .execution-list-wrapper {
        background: linear-gradient(135deg, #f0f9ff 0%, #f8fafc 100%);
        border-radius: 18px;
        padding: 28px;
        border: 1px solid #e0f2fe;
      }

      .execution-list-title {
        display: flex;
        align-items: center;
        gap: 10px;
        font-size: 14px;
        text-transform: uppercase;
        letter-spacing: 0.1em;
        color: #0369a1;
        margin: 0 0 20px 0;
        font-weight: 700;
      }

      .title-icon {
        color: #0ea5e9;
        font-size: 18px;
      }

      .execution-list {
        list-style: none;
        padding: 0;
        margin: 0;
        display: grid;
        gap: 14px;
      }

      .execution-list-item {
        display: flex;
        align-items: flex-start;
        gap: 14px;
        font-size: 15px;
        color: #1e293b;
        line-height: 1.6;
      }

      .list-check {
        color: #0ea5e9;
        flex-shrink: 0;
        margin-top: 2px;
        background: rgba(14, 165, 233, 0.1);
        border-radius: 50%;
        padding: 2px;
      }

      .list-text {
        flex: 1;
      }

      /* Responsive */
      @media (max-width: 991px) {
        .about-center-why-grid {
          grid-template-columns: 1fr;
        }
      }

      @media (max-width: 768px) {
        .values-section {
          padding: 30px 0;
        }

        .execution-banner {
          height: 240px;
        }

        .execution-body {
          padding: 24px;
        }

        .execution-badge {
          font-size: 14px;
          padding: 8px 16px;
        }

        .section-title-primary,
        .section-title-secondary {
          font-size: 24px;
        }
      }

      @media (max-width: 480px) {
        .about-center-why-point {
          padding: 16px 14px 16px 12px;
        }

        .about-center-why-index {
          min-width: 42px;
          font-size: 12px;
        }

        .about-center-why-point-text {
          font-size: 14px;
        }

        .execution-list-item {
          gap: 10px;
        }
      }
    `}</style>
  </>
  );
}